import React from "react";
import "../styles/perfil.css";
import {
  Media,
  Progress,
  Button,
  UncontrolledTooltip as Uct,
} from "reactstrap";
import FrmIdiomas from "../forms/FrmIdiomas";
import Modalform from "../components/Modalform";
import FrmFormacion from "../forms/FrmFormacion";
import FrmExperiencia from "../forms/Experiencia/FrmExperiencia";
import FrmPreferencias from "../forms/FrmPreferencias";
import FrmInfoPersonal from "../forms/FrmInfoPersonal";
import FrmConocimientos from "../forms/FrmConocimientos";
import {
  FontIcon,
  Card,
  CardHeader,
  CardSubtitle,
  Button as ButtonMd,
} from "react-md";
import { IconRotator } from "@react-md/icon";
import { Collapse } from "@react-md/transition";

import { KeyboardArrowDownSVGIcon } from "@react-md/material-icons";

import { dat_secciones, getPerfil } from "../requests/req_perfil";
import { buildFullNameUser } from "../requests/utils";
import { initOnLoad } from "apexcharts";

export default function Perfil() {
  const [secPersonal, setSecPersonal] = React.useState({});
  const [secPerfil, setPerfil] = React.useState({});
  const [secDatosLab, setSecDatosLab] = React.useState([]);
  const [secConocimientos, setSecConocimientos] = React.useState([]);
  const [secIdiomas, setSecIdiomas] = React.useState([]);
  const [secExperiencia, setSecExperiencia] = React.useState([]);
  const [secFormacion, setSecFormacion] = React.useState([]);
  const [secPrestaciones, setSecPrestaciones] = React.useState([]);

  const [expandable, setExpandable] = React.useState(["Información personal"]);
  const [typeModal, setTypeModal] = React.useState();

  const infoPersonal = React.useMemo(() => {
    return secPersonal;
  }, [secPersonal]);

  const infoPerfil = React.useMemo(() => {
    return secPerfil;
  }, [secPerfil]);

  const salario = React.useMemo(() => {
    return secDatosLab[0]?.SueldoDeseado || 0;
  }, [secDatosLab]);

  const porcentaje = React.useMemo(() => {
    return secPerfil?.porcentaje || 5;
  }, [secPerfil]);

  React.useEffect(() => {
    (async () => {
      getPerfil((p) => desetructurarReponse(p));
    })();
  }, []);

  const desetructurarReponse = (data) => {
    if (!data) return null;
    const tablas = data;

    
    if (tablas && tablas.tabla1) {
      setPerfil(tablas.tabla1[0]);
    }

    if (tablas && tablas.tabla2) {
      setSecPersonal(tablas.tabla2[0]);
    }
    if (tablas && tablas.tabla3) {
      setSecConocimientos(tablas.tabla3);
    }

    if (tablas && tablas.tabla4) {
      setSecIdiomas(tablas.tabla4);
    }
    if (tablas && tablas.tabla5) {
      setSecExperiencia(tablas.tabla5);
    }
    if (tablas && tablas.tabla6) {
      setSecFormacion(tablas.tabla6);
    }
    if (tablas && tablas.tabla7) {
      setSecDatosLab(tablas.tabla7);
    }
    if (tablas && tablas.tabla8) {
      setSecPrestaciones(tablas.tabla8);
    }
  };

  const sectionProfilePhoto = () => {
    return (
      <div className="ARC_Prfl row ">
        <div className="ARC_Prfl_izquierda col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <Media className="APL_Dv_lft">
            <Media left>
              <img
                src={
                  localStorage.getItem("foto") != null
                    ? localStorage.getItem("foto")
                    : process.env.PUBLIC_URL + "/images/default-avatar.png"
                }
                alt=" "
                id="img_ft_prfl"
                onClick={(e) => {
                  setTypeModal("Cambiar Foto de Perfil");
                  document.getElementById("BtnMdl").click();
                  //this.cambiaFoto(e)
                }}
              />

              <Uct placement="bottom" target="img_ft_prfl">
                Cambiar foto de perfil
              </Uct>
            </Media>
            <Media body className="infoPersonal">
              <div>
                <FontIcon>person</FontIcon>
                <label className="lbl_md">Nombre:</label>
                <label id="lblNombre">
                  {buildFullNameUser({
                    firtsName: infoPersonal?.primerNombre,
                    middleName: infoPersonal?.apellidoPaterno,
                    lastName: infoPersonal?.apellidoMaterno,
                  })}
                </label>
              </div>
              <div>
                <FontIcon>email</FontIcon>
                <label className="lbl_md">Correo electrónico:</label>
                <label id="lblcorreo">{infoPersonal?.correo || ""}</label>
              </div>
              <div>
                <FontIcon>phone</FontIcon>
                <label className="lbl_md">Celular:</label>
                <label id="lbltel1">{infoPersonal?.celular || ""}</label>
              </div>
              <div>
                <FontIcon>monetization_on</FontIcon>
                <label className="lbl_md" id="lblSueldo">
                  Expectativa salarial: ${salario}.00 mxn
                </label>
              </div>
            </Media>
          </Media>
        </div>
        <div className="ARC_Prfl_derecha col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div className="APL_Dv_Rgt">
            <label className="lbl_md">Perfil completado en un : &nbsp;</label>
            <label className="lbl_prc">{porcentaje} %</label>
            <Progress animated color="info" value={porcentaje} />
            <div className="dv_Encuesta">
              <Button
                className="btn_primary"
                onClick={(e) => {
                  setTypeModal("Entrevistas de Recursos Humanos");
                  document.getElementById("BtnMdl").click();
                }}
              >
                Entrevistas Recursos Humanos
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderSections = ({ orientation }) => {
    const sections = dat_secciones.filter(
      (item) => item.ubicacion === orientation
    );
    return sections.map((item, index) => {
      return (
        <Card
          key={`card-${index}`}
          bordered={20}
          style={{
            padding: "0 10px",
          }}
        >
          <CardHeader
            className="Crd_Header"
            beforeChildren={
              <div>
                <label className="lbl_bg">{item.seccion}</label>
                <span
                  id={"Dot_" + item.sc}
                  className={`dot ${isDot({ nameSection: item.seccion })}`}
                />
              </div>
            }
            afterChildren={
              <ButtonMd
                id={"expand-card-button" + index}
                onClick={(e) => {
                  setExpandable((olds) => {
                    const findIndex = olds.findIndex(
                      (old) => old === item.seccion
                    );
                    if (findIndex > -1) {
                      const newOld = [...olds];
                      newOld.splice(findIndex, 1);
                      return newOld;
                    } else {
                      return [...olds, item.seccion];
                    }
                  });
                }}
                buttonType="icon"
                aria-label="Expand"
                theme="clear"
              >
                <IconRotator
                  rotated={
                    expandable.find((exp) => exp === item.seccion) === undefined
                      ? true
                      : false
                  }
                >
                  <KeyboardArrowDownSVGIcon />
                </IconRotator>
              </ButtonMd>
            }
          />

          <Collapse
            collapsed={
              expandable.find((exp) => exp === item.seccion) === undefined
                ? true
                : false
            }
          >
            <CardSubtitle className="dv_Content_seccion">
              {renderSection({ nameSection: item.seccion })}
            </CardSubtitle>
          </Collapse>
        </Card>
      );
    });
  };

  const renderSection = ({ nameSection }) => {
    switch (nameSection) {
      case "Información personal": {
        return (
          <FrmInfoPersonal
            datos={infoPersonal}
            handleUpdate={() => {
              getPerfil((p) => desetructurarReponse(p));
            }}
          />
        );
      }
      case "Experiencia profesional":
        return (
          <FrmExperiencia
            id="frmexp"
            datos={secExperiencia}
            handleUpdate={() => {
              getPerfil((p) => desetructurarReponse(p));
            }}
          />
        );

      case "Conocimientos Técnicos":
        return (
          <FrmConocimientos
            datos={secConocimientos}
            perfil={infoPerfil}
            handleUpdate={() => {
              getPerfil((p) => desetructurarReponse(p));
            }}
          />
        );
      case "Formación":
        return (
          <FrmFormacion
            datos={secFormacion}
            handleUpdate={() => {
              getPerfil((p) => desetructurarReponse(p));
            }}
          />
        );
      case "Idiomas":
        return (
          <FrmIdiomas
            datos={secIdiomas}
            handleUpdate={() => {
              getPerfil((p) => desetructurarReponse(p));
            }}
          />
        );
      case "Datos Laborales":
        return (
          <FrmPreferencias
            datos={secDatosLab}
            preferencias={secPrestaciones}
            handleUpdate={() => {
              getPerfil((p) => desetructurarReponse(p));
            }}
          />
        );
      default:
        return <label>No se encontró el Form</label>;
    }
  };

  const isDot = ({ nameSection }) => {
    switch (nameSection) {
      case "Información personal": {
        return infoPersonal && Object.keys(infoPersonal).length > 0
          ? "si"
          : "no";
      }
      case "Experiencia profesional":
        return secExperiencia && secExperiencia.length > 0 ? "si" : "no";

      case "Conocimientos Técnicos":
        return secConocimientos && secConocimientos.length > 0 ? "si" : "no";
      case "Formación":
        return secFormacion && secFormacion.length > 0 ? "si" : "no";
      case "Idiomas":
        return secIdiomas && secIdiomas.length > 0 ? "si" : "no";
      case "Datos Laborales":
        return secDatosLab && secDatosLab.length > 0 ? "si" : "no";
      default:
        return "no";
    }
  };
  return (
    <div className="ARC_Perfil container-fluid">
      {sectionProfilePhoto()}
      <div className="ARC_Prfl_Full row">
        <div className="ARC_Prfl_Lft col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          {renderSections({ orientation: "izquierda" })}
        </div>
        <div className="ARC_Prfl_Rgt col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          {renderSections({ orientation: "derecha" })}
        </div>
      </div>

      <Modalform modulo={typeModal} btnsv={null} cerrar={() => {}} />
    </div>
  );
}
